var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { DropdownContext } from './DropdownContext';
import { Button } from '../button';
import ButtonIcon from '../icon/ButtonIcon';
import Icon from '../icon/Icon';
import { mdiChevronDown } from '@mdi/js';
import { COLORS } from '../color';
export var DropdownToggleType;
(function (DropdownToggleType) {
    DropdownToggleType["iconButton"] = "iconButton";
    DropdownToggleType["textButton"] = "textButton";
    DropdownToggleType["avatarButton"] = "avatarButton";
})(DropdownToggleType || (DropdownToggleType = {}));
var DropdownToggle = /** @class */ (function (_super) {
    __extends(DropdownToggle, _super);
    function DropdownToggle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DropdownToggle.prototype.render = function () {
        var _a = this.props, className = _a.className, textButton = _a.textButton, textButtonSize = _a.textButtonSize, textButtonStyle = _a.textButtonStyle, iconTitle = _a.iconTitle, type = _a.type, iconColor = _a.iconColor, imageUrl = _a.imageUrl, iconAvatarSize = _a.iconAvatarSize, imageHeight = _a.imageHeight, imageWidth = _a.imageWidth, badge = _a.badge, iconPosition = _a.iconPosition, isRoundedButton = _a.isRoundedButton, hover = _a.hover, textButtonColor = _a.textButtonColor, hoverIconColor = _a.hoverIconColor, sizeIcon = _a.sizeIcon, iconPath = _a.iconPath, isHoverArea = _a.isHoverArea;
        switch (type) {
            case DropdownToggleType.textButton:
                return (React.createElement(DropdownContext.Consumer, null, function (value) { return (React.createElement("div", { id: value.id, className: (badge ? 'dropdown-button-badge ' : '') + (className ? className : '') },
                    React.createElement(Button, { iconPosition: iconPosition, iconPath: iconPath, color: textButtonColor ? textButtonColor : undefined, disabled: value.disabled, size: textButtonSize ? textButtonSize : 'sm', id: value.id, style: textButtonStyle, isRoundedButton: isRoundedButton, hover: hover, type: 'button' }, textButton),
                    badge)); }));
            case DropdownToggleType.iconButton:
                return (React.createElement(DropdownContext.Consumer, null, function (value) { return (React.createElement("div", { className: (badge ? 'dropdown-icon-button-badge ' : '') + (className ? className : '') },
                    React.createElement(ButtonIcon, { iconPath: iconPath, color: iconColor ? iconColor : COLORS.gray600, size: sizeIcon, title: iconTitle ? iconTitle : '', hoverIconColor: hoverIconColor, isHoverArea: isHoverArea, id: value.id, disabled: value.disabled }),
                    badge)); }));
            case DropdownToggleType.avatarButton:
                return (React.createElement(DropdownContext.Consumer, null, function (value) { return (React.createElement("div", { className: (badge ? 'dropdown-avatar-badge ' : '') + (className ? className : '') },
                    React.createElement("button", { id: value.id, className: 'dropdown-avatar button-icon' },
                        React.createElement("img", { src: imageUrl, width: imageWidth ? imageWidth : 32, height: imageHeight ? imageHeight : 32, alt: 'Аватар', className: 'dropdown-avatar-img' }),
                        React.createElement(Icon, { path: mdiChevronDown, color: iconColor ? iconColor : COLORS.white, size: iconAvatarSize ? iconAvatarSize : 1 })),
                    badge)); }));
        }
    };
    return DropdownToggle;
}(Component));
export { DropdownToggle };
//# sourceMappingURL=DropdownToggle.js.map